
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/book-demo",
      function () {
        return require("private-next-pages/book-demo/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/book-demo"])
      });
    }
  